import gql from 'graphql-tag';

export default gql`
  query getIntegrationsManifest(
    $channelId: UUID!
    $domain: IntegrationDomain!
  ) {
    getIntegrationsManifest(channelId: $channelId, domain: $domain) {
      integrations {
        vtsIntegrationId
        provider
        domain
      }
    }
  }
`;
